module.exports = __webpack_public_path__ + "e28878139af1582e4b1441f2298c9fa0.svg";